import React, { Suspense } from 'react'
import 'antd/dist/antd.css'
import 'react-day-picker/lib/style.css'
import '../../assets/style/styles.css'
import 'react-image-gallery/styles/css/image-gallery.css'
import '../../assets/scss/style.scss'
import '../../assets/scss/common/common.scss'
import { Route, Switch } from 'react-router-dom'
import Loading from '../common/Loading'
import routes from '../../routes/router'
function App() {
    return (
        <section className="page-body">
            <main>
                <Loading />
                <Suspense fallback={<div>{' '}</div>}>
                    <Switch>
                        {routes.map(({ component: Component, name, exact, path, layout: Layout }) => {
                            return (
                                <Route
                                    key={name}
                                    exact={exact}
                                    path={path}
                                    render={(routeProps: any) => {
                                        return (
                                            <Layout>
                                                <Component {...routeProps} />
                                            </Layout>
                                        )
                                    }}
                                />
                            )
                        })}
                    </Switch>
                </Suspense>
            </main>
        </section>
    )
}

export default App
